import { MAP_DEFAULTS } from './constants'

export const coordsToGoogleMapCoords = coords =>
  coords ? ({ lat: coords.latitude, lng: coords.longitude }) : {}

export const validateCenterCoords = (coords) => coords.latitude && coords.longitude ? coords : MAP_DEFAULTS.center
